import { Workflow } from "lucide-react";

import { CcCampaignAutomationDemo } from "@/components/home/growth-features/CcCampaignAutomationDemo";
import type { SeoWorkflowCampaignCardCopy } from "./seo-workflow-copy";
import { CcSeoWorkflowCard } from "./CcSeoWorkflowCard";

type CcSeoWorkflowCampaignProps = {
  copy: SeoWorkflowCampaignCardCopy;
};

export function CcSeoWorkflowCampaign({ copy }: CcSeoWorkflowCampaignProps) {
  return (
    <CcSeoWorkflowCard
      id="campaign"
      title={copy.title}
      description={copy.description}
      badge={copy.badge}
      icon={Workflow}
    >
      <CcCampaignAutomationDemo copy={copy.demo} />
    </CcSeoWorkflowCard>
  );
}
